import { render, staticRenderFns } from "./TestDataDialog.vue?vue&type=template&id=4feb8b64&scoped=true"
import script from "./TestDataDialog.vue?vue&type=script&lang=js"
export * from "./TestDataDialog.vue?vue&type=script&lang=js"
import style0 from "./TestDataDialog.vue?vue&type=style&index=0&id=4feb8b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feb8b64",
  null
  
)

export default component.exports